import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { IInputFieldArgs } from '@/modules/mixing/ts/rustmix-buyer.types';
import styles from './index.module.sass';
import classNames from 'classnames';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';
import { createWheelHandler } from '@/modules/helpers/create-wheel-handler/index.helper';

export const WeightInputField = ({
  data,
  setValue,
  renewTotalData,
  className,
}: IInputFieldArgs) => {
  const handleWheel = createWheelHandler(
    data,
    setValue,
    { field: 'weight' },
    renewTotalData,
  );
  return (
    <InputWithSign
      float={true}
      inputClassName={classNames(styles.inpInner)}
      className={classNames(styles.input, className)}
      prefix=""
      label="вес"
      postfix="т"
      value={data.weight}
      onClick={handleClick}
      onChange={(e: any) => {
        setValue &&
          setValue({
            ...data,
            weight: e.target.value.replace(/[^0-9.]/g, ''),
          });
      }}
      onWheel={handleWheel}
      onBlur={renewTotalData}
    />
  );
};
